/**
 * WACC attribution persistence shim.
 * Captures GOOG-38 click attribution params into first-party storage and
 * writes them to Shopify cart attributes before checkout.
 * Revision: 2026-05-27
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'wacc_attribution';
  var PARAM_KEYS = ['gclid', 'fbclid', 'ttclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function readCookie(name) {
    var prefix = name + '=';
    var cookies = document.cookie ? document.cookie.split(';') : [];

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();

      if (cookie.indexOf(prefix) === 0) {
        return decodeURIComponent(cookie.slice(prefix.length));
      }
    }

    return null;
  }

  function writeCookie(name, value) {
    var expiry = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expiry + '; path=/; SameSite=Lax';
  }

  function readStoredAttribution() {
    var stored = null;

    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      stored = null;
    }

    if (!stored) {
      stored = readCookie(STORAGE_KEY);
    }

    if (!stored) {
      return null;
    }

    try {
      return JSON.parse(stored);
    } catch (error) {
      return null;
    }
  }

  function storeAttribution(attribution) {
    var serialized = JSON.stringify(attribution);

    writeCookie(STORAGE_KEY, serialized);

    try {
      window.localStorage.setItem(STORAGE_KEY, serialized);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  function captureFromLocation() {
    var params = new URLSearchParams(window.location.search);
    var captured = {};

    PARAM_KEYS.forEach(function (key) {
      var value = params.get(key);

      if (value) {
        captured[key] = value;
      }
    });

    if (Object.keys(captured).length > 0) {
      captured._captured_at = new Date().toISOString();
      storeAttribution(captured);
    }
  }

  function buildCartAttributes(attribution) {
    var attributes = {};

    PARAM_KEYS.forEach(function (key) {
      if (attribution[key]) {
        attributes['attribution_' + key] = attribution[key];
      }
    });

    if (attribution._captured_at) {
      attributes.attribution_captured_at = attribution._captured_at;
    }

    return attributes;
  }

  function writeToCart() {
    var attribution = readStoredAttribution();

    if (!attribution) {
      return Promise.resolve();
    }

    var attributes = buildCartAttributes(attribution);

    if (Object.keys(attributes).length === 0) {
      return Promise.resolve();
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true,
    }).catch(function () {});
  }

  function bindCartEvents() {
    document.addEventListener('submit', function (event) {
      var action = event.target && event.target.action ? event.target.action : '';

      if (action.indexOf('/cart/add') !== -1) {
        writeToCart();
      }
    });

    document.addEventListener('click', function (event) {
      var trigger =
        event.target && event.target.closest
          ? event.target.closest('[name=checkout], [href*="/checkout"], button[type=submit][name=checkout]')
          : null;

      if (trigger) {
        writeToCart();
      }
    });
  }

  window.waccAttribution = window.waccAttribution || {};
  window.waccAttribution.writeToCart = writeToCart;

  captureFromLocation();
  bindCartEvents();
})();
